import { queryOptions } from "@tanstack/react-query";
import type { BikeModelDto, PaginatedResponse } from "@yalana/contracts";
import { fetchApi } from "../../../shared/infrastructure/api-client";

/**
 * Bike-model queries, kept out of `bikes.queries.ts` so that file stays at its
 * baselined length (`scripts/check-file-length.sh`).
 */
export const bikeModelQueries = {
  /**
   * Every model of one customer.
   *
   * BEL-730: unscoped, this offered another customer's models in the bike
   * form, and a bike ended up pointing at a model it did not own. Omitting
   * `customerId` keeps the previous unscoped behaviour for callers that have
   * no customer in context.
   */
  all: (customerId?: string) =>
    queryOptions({
      queryKey: ["bikes", "models", "all", customerId] as const,
      queryFn: async () => {
        const res = await fetchApi<PaginatedResponse<BikeModelDto>>(
          "/api/bikes/models",
          {
            searchParams: {
              page: "1",
              pageSize: "500",
              ...(customerId ? { customerId } : {}),
            },
          },
        );
        return res.data;
      },
    }),
};
